import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AssetPerformanceKPILineDataDashboard } from '../services/getAssetPerformanceKPIData'

export interface flowKPIAssetDataState {
  isLoading: boolean
  errorMessage: string | null
  flowKPIAssetData: AssetPerformanceKPILineDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flowKPIAssetDataState = {
  flowKPIAssetData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flowKPIGraphDataState = createSlice({
  name: 'flowKPIAssetDataState',
  initialState,
  reducers: {
    flowKPIGraphDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flowKPIAssetData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flowKPIGraphDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        flowKPIAssetData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flowKPIGraphDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flowKPIAssetData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flowKPIGraphDataLoadingAction,
  flowKPIGraphDataUpdateAction,
  flowKPIGraphDataErrorAction
} = flowKPIGraphDataState.actions

export default flowKPIGraphDataState.reducer
